(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["combo-builder"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-combo-builder]').forEach(function (builder) {
  if (builder.dataset.initialized === 'true') return;
  builder.dataset.initialized = 'true';

  var coolerSelect = builder.querySelector('[data-combo-cooler]');
  var patchSelect = builder.querySelector('[data-combo-patch]');
  var patchTwoSelect = builder.querySelector('[data-combo-patch-two]');
  var coolerChoices = builder.querySelector('[data-combo-cooler-choices]');
  var patchChoices = builder.querySelector('[data-combo-patch-choices]');
  var patchTwoChoices = builder.querySelector('[data-combo-patch-two-choices]');
  var categoryGroups = builder.querySelectorAll('[data-combo-category-group]');
  var coolerCard = builder.querySelector('[data-combo-cooler-card]');
  var patchCard = builder.querySelector('[data-combo-patch-card]');
  var patchTwoCard = builder.querySelector('[data-combo-patch-two-card]');
  var total = builder.querySelector('[data-combo-total]');
  var summary = builder.querySelector('[data-combo-summary]');
  var addButton = builder.querySelector('[data-combo-add]');
  var status = builder.querySelector('[data-combo-status]');
  var clearPatchTwo = builder.querySelector('[data-combo-clear-patch-two]');
  var currency = builder.dataset.currency || 'AUD';

  function money(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
      style: 'currency',
      currency: currency
    }).format(cents / 100);
  }

  function cleanTitle(title) {
    return String(title || '')
      .replace(/fucks?/gi, 'F*')
      .replace(/shit/gi, 'S***');
  }

  function imageSource(product, variant) {
    if (variant && variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
    if (product.featured_image && typeof product.featured_image === 'string') return product.featured_image;
    if (product.featured_image && product.featured_image.src) return product.featured_image.src;
    if (product.images && product.images[0]) return product.images[0].src || product.images[0];
    return '';
  }

  function normaliseProducts(products, mode) {
    var items = [];

    products.forEach(function (product) {
      if ((mode === 'patch' || mode === 'australian-patch' || mode === 'military-patch') && (!/patch/i.test(product.title) || /combo|tee/i.test(product.title))) return;
      if (mode === 'australian-patch' && !/austral/i.test(product.title)) return;
      if (mode === 'military-patch' && !/military|army|navy|air force|raaf|veteran|police|corrections|medic|fire fighter|bullet|whiskey tango|foxtrot/i.test(product.title)) return;

      if (mode === 'tinnie') {
        if (product.title !== 'Tactical Tinnie Holder') return;
        (product.variants || []).forEach(function (variant) {
          if (variant.available === false) return;
          items.push({
            id: variant.id,
            title: cleanTitle(product.title + ' — ' + variant.title),
            price: Math.round(Number(variant.price || 0) * 100),
            image: imageSource(product, variant)
          });
        });
        return;
      }

      var available = (product.variants || []).filter(function (variant) {
        return variant.available !== false;
      });
      var variant = mode === 'vest'
        ? available.find(function (item) { return /^single\s*\/\s*no$/i.test(item.title); })
          || available.find(function (item) { return /^single$/i.test(item.title); })
          || available[0]
        : available[0];
      if (!variant) return;

      items.push({
        id: variant.id,
        title: cleanTitle(product.title),
        price: Math.round(Number(variant.price || 0) * 100),
        image: imageSource(product, variant)
      });
    });

    return items;
  }

  function populate(select, items) {
    var placeholder = select.options[0];
    var seen = {};
    select.innerHTML = '';
    select.appendChild(placeholder);

    items.forEach(function (item) {
      if (seen[item.id]) return;
      seen[item.id] = true;
      var option = document.createElement('option');
      option.value = item.id;
      option.dataset.price = item.price;
      option.dataset.title = item.title;
      option.dataset.image = item.image;
      option.textContent = item.title + ' — ' + money(item.price);
      select.appendChild(option);
    });
  }

  function renderChoices(select, container) {
    container.innerHTML = '';
    Array.from(select.options).slice(1).forEach(function (option) {
      var choice = document.createElement('button');
      var imageWrap = document.createElement('span');
      var copy = document.createElement('span');
      var title = document.createElement('span');
      var price = document.createElement('strong');

      choice.type = 'button';
      choice.className = 'combo-builder__choice';
      choice.dataset.value = option.value;
      choice.setAttribute('role', 'option');
      choice.setAttribute('aria-selected', 'false');

      imageWrap.className = 'combo-builder__choice-image';
      if (option.dataset.image) {
        var image = document.createElement('img');
        image.src = option.dataset.image;
        image.alt = option.dataset.title;
        image.width = 220;
        image.height = 220;
        image.loading = 'lazy';
        imageWrap.appendChild(image);
      } else {
        imageWrap.textContent = '—';
      }

      copy.className = 'combo-builder__choice-copy';
      title.textContent = option.dataset.title;
      price.textContent = money(Number(option.dataset.price || 0));
      copy.appendChild(title);
      copy.appendChild(price);
      choice.appendChild(imageWrap);
      choice.appendChild(copy);

      choice.addEventListener('click', function () {
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
      container.appendChild(choice);
    });
  }

  function syncChoices(select, container) {
    container.querySelectorAll('[data-value]').forEach(function (choice) {
      var selected = choice.dataset.value === select.value;
      choice.classList.toggle('is-selected', selected);
      choice.setAttribute('aria-selected', String(selected));
    });
  }

  function setupBrowser(browser, rail) {
    browser.querySelectorAll('[data-combo-scroll]').forEach(function (button) {
      button.addEventListener('click', function () {
        rail.scrollBy({
          left: Number(button.dataset.comboScroll) * rail.clientWidth * 0.85,
          behavior: 'smooth'
        });
      });
    });
  }

  function fetchProducts(endpoint) {
    return fetch(endpoint, { headers: { 'Accept': 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('products');
        return response.json();
      })
      .then(function (payload) {
        return payload.products || [];
      })
      .catch(function () {
        return [];
      });
  }

  function loadCategory(button, group) {
    var target = group.dataset.target;
    var select = target === 'cooler' ? coolerSelect : target === 'patch2' ? patchTwoSelect : patchSelect;
    var choices = target === 'cooler' ? coolerChoices : target === 'patch2' ? patchTwoChoices : patchChoices;
    var endpoints = button.dataset.endpoints.split('|');
    var mode = button.dataset.mode;

    group.setAttribute('aria-busy', 'true');
    group.querySelectorAll('button').forEach(function (item) {
      var active = item === button;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', String(active));
    });

    return Promise.all(endpoints.map(fetchProducts)).then(function (results) {
      var items;
      if (mode === 'all-coolers') {
        items = normaliseProducts(results[0] || [], 'vest')
          .concat(normaliseProducts(results[1] || [], 'tinnie'));
      } else {
        items = normaliseProducts(results.reduce(function (all, products) {
          return all.concat(products);
        }, []), mode);
      }
      populate(select, items);
      select.value = '';
      renderChoices(select, choices);
      updateBuilder();
    }).finally(function () {
      group.setAttribute('aria-busy', 'false');
    });
  }

  function selectedOption(select) {
    return select.options[select.selectedIndex];
  }

  function updateCard(select, card) {
    var option = selectedOption(select);
    var image = card.querySelector('[data-combo-image]');
    var placeholder = card.querySelector('[data-combo-placeholder]');
    var title = card.querySelector('[data-combo-title]');
    var hasSelection = Boolean(option && option.value);

    if (!hasSelection) {
      image.hidden = true;
      image.removeAttribute('src');
      image.alt = '';
      placeholder.hidden = false;
      title.textContent = select.options[0].textContent;
      return;
    }

    title.textContent = option.dataset.title;
    if (option.dataset.image) {
      image.src = option.dataset.image;
      image.alt = option.dataset.title;
      image.hidden = false;
      placeholder.hidden = true;
    } else {
      image.hidden = true;
      placeholder.hidden = false;
    }
  }

  function updateBuilder() {
    updateCard(coolerSelect, coolerCard);
    updateCard(patchSelect, patchCard);
    updateCard(patchTwoSelect, patchTwoCard);
    syncChoices(coolerSelect, coolerChoices);
    syncChoices(patchSelect, patchChoices);
    syncChoices(patchTwoSelect, patchTwoChoices);

    var cooler = selectedOption(coolerSelect);
    var patch = selectedOption(patchSelect);
    var patchTwo = selectedOption(patchTwoSelect);
    var complete = Boolean(cooler.value && patch.value);
    addButton.disabled = !complete;
    clearPatchTwo.hidden = !(patchTwo && patchTwo.value);
    status.textContent = '';

    if (!complete) {
      total.textContent = '—';
      summary.textContent = '';
      return;
    }

    var cents = Number(cooler.dataset.price || 0) + Number(patch.dataset.price || 0)
      + (patchTwo && patchTwo.value ? Number(patchTwo.dataset.price || 0) : 0);
    total.textContent = money(cents);
    summary.textContent = patchTwo && patchTwo.value
      ? builder.dataset.twoPatchSummary
      : builder.dataset.onePatchSummary;
  }

  coolerSelect.addEventListener('change', updateBuilder);
  patchSelect.addEventListener('change', updateBuilder);
  patchTwoSelect.addEventListener('change', updateBuilder);
  clearPatchTwo.addEventListener('click', function () {
    patchTwoSelect.value = '';
    updateBuilder();
  });
  setupBrowser(builder.querySelector('[data-combo-cooler-browser]'), coolerChoices);
  setupBrowser(builder.querySelector('[data-combo-patch-browser]'), patchChoices);
  setupBrowser(builder.querySelector('[data-combo-patch-two-browser]'), patchTwoChoices);
  categoryGroups.forEach(function (group) {
    group.querySelectorAll('button').forEach(function (button) {
      button.addEventListener('click', function () {
        loadCategory(button, group);
      });
    });
  });

  addButton.addEventListener('click', function () {
    var cooler = selectedOption(coolerSelect);
    var patch = selectedOption(patchSelect);
    var patchTwo = selectedOption(patchTwoSelect);
    if (!cooler.value || !patch.value) return;

    addButton.disabled = true;
    addButton.textContent = builder.dataset.addingText;
    status.textContent = '';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [
          { id: Number(cooler.value), quantity: 1, properties: { '_Combo': 'Build your own' } },
          { id: Number(patch.value), quantity: 1, properties: { '_Combo': 'Build your own' } }
        ].concat(patchTwo && patchTwo.value
          ? [{ id: Number(patchTwo.value), quantity: 1, properties: { '_Combo': 'Build your own — second patch' } }]
          : [])
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart');
        return response.json();
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function () {
        status.textContent = builder.dataset.errorText;
        addButton.textContent = builder.dataset.addText;
        addButton.disabled = false;
      });
  });

  renderChoices(coolerSelect, coolerChoices);
  renderChoices(patchSelect, patchChoices);
  renderChoices(patchTwoSelect, patchTwoChoices);
  builder.classList.add('combo-builder--enhanced');

  Promise.all(Array.from(categoryGroups).map(function (group) {
    return loadCategory(group.querySelector('.is-active'), group);
  }));

  updateBuilder();
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-patch-designer"] && !Shopify.designMode) return;
  try {
    function initialisePersonalisedProduct(root) {
    if (root.dataset.personalisedReady === 'true') return;
    var controls = root.querySelector('[data-personalised-controls]');
    var stage = root.querySelector('[data-personalised-stage]');
    if (!controls || !stage) return;
    var variantsNode = controls.querySelector('[data-personalised-variants]');
    var variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    var kind = controls.dataset.productKind;
    var sizeSelect = controls.querySelector('[data-personalised-size]');
    var packSelect = controls.querySelector('[data-personalised-pack]');
    var variantSelect = controls.querySelector('[data-personalised-variant]');
    var threadSelect = controls.querySelector('[data-personalised-thread]');
    var confirmInput = controls.querySelector('[data-personalised-confirm]');
    var packProperty = controls.querySelector('[data-personalised-pack-property]');
    var priceSummary = controls.querySelector('[data-personalised-price]');
    var previewStatus = root.querySelector('[data-personalised-preview-status]');
    var activeInput = controls.querySelector('[data-personalised-text]');
    var threadColours = { White: '#f7f4eb', Black: '#111111', Red: '#c62828', Blue: '#1558a6' };

    function normalise(value) {
      if (kind === 'callsign') return value.replace(/[^A-Za-z0-9 '\-]/g, '').replace(/ {2,}/g, ' ').replace(/^ /, '').slice(0,16).toUpperCase();
      return value.replace(/[^A-Za-z0-9 .&'\-+]/g, '').slice(0,16).toUpperCase();
    }
    function countFromText(value) { if (String(value).indexOf('5') !== -1) return 5; if (String(value).indexOf('2') !== -1) return 2; return 1; }
    function selectedPackCount() {
      if (kind === 'dog') return 2;
      var option = packSelect ? packSelect.options[packSelect.selectedIndex] : variantSelect.options[variantSelect.selectedIndex];
      return Number(option && option.dataset.packCount) || countFromText(option ? option.textContent : '1');
    }
    function selectedVariant() {
      if (kind === 'callsign') return variants.find(function (variant) { return variant.option1 === sizeSelect.value && variant.option2 === packSelect.value; });
      return variants.find(function (variant) { return String(variant.id) === String(variantSelect.value); });
    }
    function money(cents) {
      var currency = window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'AUD';
      return new Intl.NumberFormat(document.documentElement.lang || 'en-AU',{style:'currency',currency:currency}).format(cents / 100);
    }
    function updateItems() {
      var count = selectedPackCount();
      controls.querySelectorAll('[data-personalised-item]').forEach(function (item) {
        var visible = Number(item.dataset.itemIndex) <= count;
        item.hidden = !visible;
        item.querySelectorAll('input').forEach(function (input) { input.disabled = !visible; input.required = visible; });
      });
      packProperty.value = count;
      if (!activeInput || activeInput.disabled) activeInput = controls.querySelector('[data-personalised-text]:not(:disabled)');
    }
    function updateVariant() {
      var variant = selectedVariant();
      if (!variant) return;
      var variantInput = root.querySelector('[name="id"]');
      if (variantInput && String(variantInput.value) !== String(variant.id)) {
        variantInput.value = variant.id;
        variantInput.dispatchEvent(new Event('change',{bubbles:true}));
      }
      var quantityInput = root.querySelector('[name="quantity"]');
      if (quantityInput) quantityInput.value = 1;
      root.querySelectorAll('[data-regular-price],[data-sale-price]').forEach(function (node) { node.textContent = money(variant.price); });
      var sku = root.querySelector('.variant-sku');
      if (sku) sku.textContent = variant.sku || '';
      var count = selectedPackCount();
      var summary = controls.dataset.totalLabel + ': ' + money(variant.price);
      if (count > 1) {
        summary += ' · ' + money(Math.round(variant.price / count)) + ' ' + controls.dataset.eachLabel;
        var single = variants.find(function (item) { return countFromText(item.option2 || item.option1) === 1 && (kind !== 'callsign' || item.option1 === sizeSelect.value); });
        if (single) {
          var saving = (single.price * count) - variant.price;
          if (saving > 0) summary += ' · ' + controls.dataset.saveLabel + ' ' + money(saving);
        }
      }
      priceSummary.textContent = summary;
      return variant;
    }
    function updatePreview() {
      var value = activeInput ? normalise(activeInput.value) : '';
      if (activeInput && activeInput.value !== value) activeInput.value = value;
      var fallback = kind === 'dog' ? controls.dataset.defaultDog : (kind === 'keyring' ? controls.dataset.defaultKeyring : controls.dataset.defaultCallsign);
      root.querySelectorAll('[data-personalised-preview-text]').forEach(function (node) { node.textContent = value || fallback; node.style.setProperty('--thread-colour',threadColours[threadSelect.value] || threadColours.White); });
      if (kind === 'callsign' && sizeSelect) stage.dataset.previewSize = sizeSelect.value.indexOf('Large') !== -1 ? 'large' : 'standard';
      if (previewStatus && activeInput && activeInput.dataset.previewLabel) previewStatus.textContent = activeInput.dataset.previewLabel;
    }
    function updateButton() {
      var variant = selectedVariant();
      var valid = Boolean(variant && variant.available && confirmInput.checked);
      controls.querySelectorAll('[data-personalised-text]:not(:disabled)').forEach(function (input) { if (!input.value.trim()) valid = false; });
      var button = root.querySelector('[data-add-to-cart]');
      if (button) { button.disabled = !valid; button.setAttribute('aria-disabled',String(!valid)); }
    }
    function updateAll() { updateItems(); updateVariant(); updatePreview(); window.setTimeout(updateButton,0); }
    controls.addEventListener('focusin',function (event) { if (event.target.matches('[data-personalised-text]')) { activeInput = event.target; updatePreview(); } });
    controls.addEventListener('input',function (event) { if (event.target.matches('[data-personalised-text]')) { activeInput = event.target; updatePreview(); } updateButton(); });
    controls.addEventListener('change',updateAll);
    updateAll();
    root.dataset.personalisedReady = 'true';
  }
  document.querySelectorAll('[data-custom-patch-root]').forEach(initialisePersonalisedProduct);
  document.addEventListener('shopify:section:load',function (event) { event.target.querySelectorAll('[data-custom-patch-root]').forEach(initialisePersonalisedProduct); });
  } catch(e) { console.error(e); }
})();

})();
